import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=5d1910b8&scoped=true&"
import script from "./video-upload.vue?vue&type=script&lang=js&"
export * from "./video-upload.vue?vue&type=script&lang=js&"
import style0 from "./video-upload.vue?vue&type=style&index=0&id=5d1910b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1910b8",
  null
  
)

export default component.exports